import { EnvironmentInterface } from '@nutt/configuration';

export const environment: Readonly<EnvironmentInterface> = {
  isProduction: false,
  apiBaseUrl: 'https://vennegoor.nutt.test.m4mapp.com/api/',
  clientId: '931610fdfc7bba9e3f9cebb338dae9b4',
  avatarBaseUrl: 'https://s3-eu-west-1.amazonaws.com/nutt-vennegoor-test-ypoqj/',
};
